// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Cn from "../../../../node_modules/rescript-classnames/lib/es6_global/src/Cn.bs.js";
import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Js_dict from "../../../../node_modules/rescript/lib/es6/js_dict.js";
import * as $$Promise from "../../../../node_modules/@ryyppy/rescript-promise/lib/es6_global/src/Promise.bs.js";
import * as Belt_Array from "../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as CSS$Showside from "./CSS.bs.js";
import * as Belt_SortArray from "../../../../node_modules/rescript/lib/es6/belt_SortArray.js";
import * as Image$Showside from "../components/Image.bs.js";
import * as Spread$Showside from "./Spread.bs.js";
import * as Shopify$Showside from "./Shopify.bs.js";
import * as Debugger$Showside from "./Debugger.bs.js";
import * as Cloudinary$Showside from "./Cloudinary.bs.js";
import * as ObjectFitMath$Showside from "./ObjectFitMath.bs.js";
import * as ReactDOMUtils$Showside from "./ReactDOMUtils.bs.js";
import * as ColorFromImage$Showside from "./ColorFromImage.bs.js";
import * as ResizeObserver2$Showside from "./ResizeObserver2.bs.js";
import * as CloudflareStream$Showside from "./CloudflareStream.bs.js";
import * as ConfigurationProvider$Showside from "../context/ConfigurationProvider.bs.js";
var sizes = [24, 27, 30, 32, 36, 38, 48, 51, 56, 60, 72, 84, 96, 120, 126, 144, 168, 192, 200, 240, 320, 336, 370, 375, 414, 540, 544, 600, 768, 900, 1024, 1080, 1200, 1366, 1440, 1600, 1728, 1944, 2160, 2376, 2592, 2808, 3024];
function quantize(size) {
  return Belt_Option.getWithDefault(Belt_Array.getBy(sizes, function (sizeOpt) {
    return sizeOpt >= size;
  }), 3024);
}
function getObjectPosition(position) {
  return Belt_Option.map(position, function (pos) {
    switch (pos) {
      case /* TopLeft */0:
        return "left top";
      case /* Top */1:
        return "50% top";
      case /* TopRight */2:
        return "right top";
      case /* Left */3:
        return "left 50%";
      case /* Right */4:
        return "right 50%";
      case /* BottomLeft */5:
        return "left bottom";
      case /* Bottom */6:
        return "50% bottom";
      case /* BottomRight */7:
        return "right bottom";
    }
  });
}
var cache = {};
var cacheEntryCallbacks = {};
function getCached(originalSrc) {
  return Js_dict.get(cache, originalSrc);
}
function setCached(originalSrc, entry) {
  var existing = Js_dict.get(cache, originalSrc);
  var isBetter = Belt_Option.mapWithDefault(existing, true, function (existing) {
    return entry.naturalWidth > existing.naturalWidth;
  });
  if (isBetter) {
    cache[originalSrc] = entry;
    return Belt_Array.forEach(Belt_Option.getWithDefault(Js_dict.get(cacheEntryCallbacks, originalSrc), []), function (callback) {
      Curry._1(callback, entry);
    });
  }
}
function useCached(originalSrc) {
  var match = React.useState(function () {
    return Js_dict.get(cache, originalSrc);
  });
  var setEntry = match[1];
  React.useEffect(function () {
    Curry._1(setEntry, function (param) {
      return Js_dict.get(cache, originalSrc);
    });
    var onChange = function (entry) {
      Curry._1(setEntry, function (param) {
        return entry;
      });
    };
    var callbacks = Belt_Option.getWithDefault(Js_dict.get(cacheEntryCallbacks, originalSrc), []);
    var callbacks$1 = Belt_Array.concat(callbacks, [onChange]);
    cacheEntryCallbacks[originalSrc] = callbacks$1;
    return function (param) {
      Belt_Option.forEach(Js_dict.get(cacheEntryCallbacks, originalSrc), function (callbacks) {
        var callbacks$1 = Belt_Array.keep(callbacks, function (fn) {
          return fn !== onChange;
        });
        cacheEntryCallbacks[originalSrc] = callbacks$1;
      });
    };
  }, [originalSrc, setEntry, getCached, cacheEntryCallbacks]);
  return match[0];
}
var queue = {
  contents: []
};
var pending = {
  contents: []
};
var timeout = {
  contents: undefined
};
function getPriorityBatchLimit(priority) {
  if (priority !== 0) {
    if (priority !== 1) {
      return 5;
    } else {
      return 10;
    }
  } else {
    return 100;
  }
}
function runQueueItem(item) {
  item.status.contents = /* Running */1;
  var promise = $$Promise.$$catch(Curry._1(item.run.contents, undefined).then(function (param) {
    item.status.contents = /* Finished */2;
    pending.contents = Belt_Array.keep(pending.contents, function (p) {
      return p !== item;
    });
    return Promise.resolve(undefined);
  }), function (param) {
    item.status.contents = /* Finished */2;
    pending.contents = Belt_Array.keep(pending.contents, function (p) {
      return p !== item;
    });
    return Promise.resolve(undefined);
  });
  item.promise.contents = Caml_option.some(promise);
  pending.contents.push(item);
  return promise;
}
function waitForIdle(param) {
  var promises = Belt_Array.keepMap(Belt_Array.map(pending.contents, function (pending) {
    return pending.promise.contents;
  }), function (a) {
    return a;
  });
  return Promise.all(promises).then(function (param) {
    var len = pending.contents.length;
    if (len === 0) {
      return Promise.resolve(undefined);
    } else {
      return waitForIdle(undefined);
    }
  });
}
function processQueueCycle(param) {
  Belt_Option.map(timeout.contents, function (prim) {
    clearTimeout(prim);
  });
  var first = Belt_Array.get(queue.contents, 0);
  var length = queue.contents.length;
  var batch;
  if (first !== undefined) {
    var topPriorityCount = Belt_Option.getWithDefault(Belt_Array.getIndexBy(queue.contents, function (t) {
      return t.priority.contents !== first.priority.contents;
    }), length);
    var topPriorityBatchLimit = getPriorityBatchLimit(first.priority.contents);
    var limit = topPriorityCount < topPriorityBatchLimit ? topPriorityCount : topPriorityBatchLimit;
    batch = queue.contents.splice(0, limit);
  } else {
    batch = [];
  }
  Belt_Array.forEach(batch, function (item) {
    runQueueItem(item);
  });
  timeout.contents = Caml_option.some(setTimeout(function (param) {
    waitForIdle(undefined).then(function (param) {
      processQueueCycle(undefined);
    });
  }, 0));
}
function sortQueue(queue) {
  return Belt_SortArray.stableSortBy(queue, function (a, b) {
    return a.priority.contents - b.priority.contents | 0;
  });
}
function enqueue(priority, run) {
  var item_priority = {
    contents: priority
  };
  var item_status = {
    contents: /* Queued */0
  };
  var item_run = {
    contents: run
  };
  var item_promise = {
    contents: undefined
  };
  var item = {
    priority: item_priority,
    status: item_status,
    run: item_run,
    promise: item_promise
  };
  if (priority === 0) {
    runQueueItem(item);
  } else {
    queue.contents = sortQueue(Belt_Array.concat(queue.contents, [item]));
  }
  return item;
}
function cancelQueued(item) {
  if (item.status.contents === /* Queued */0) {
    queue.contents = Belt_Array.keep(queue.contents, function (qitem) {
      return qitem !== item;
    });
    return;
  }
}
function updateQueueItem(item, priority, run) {
  if (item.status.contents === /* Queued */0) {
    if (priority === 0) {
      cancelQueued(item);
      runQueueItem(item);
      return item;
    } else {
      item.priority.contents = priority;
      item.run.contents = run;
      queue.contents = sortQueue(queue.contents);
      return item;
    }
  } else if (item.run.contents !== run) {
    return enqueue(priority, run);
  } else {
    return item;
  }
}
var __hasQueueCycleStarted = {
  contents: false
};
function __startProcessingQueueCycle(param) {
  if (!__hasQueueCycleStarted.contents) {
    __hasQueueCycleStarted.contents = true;
    setTimeout(function (param) {
      processQueueCycle(undefined);
    }, 0);
    return;
  }
}
function calcObjectFit(imgW, imgH, containerWidth, containerHeight, fit) {
  var containerSize_width = Belt_Option.getWithDefault(containerWidth, 9999999);
  var containerSize_height = Belt_Option.getWithDefault(containerHeight, 9999999);
  var containerSize = {
    width: containerSize_width,
    height: containerSize_height
  };
  var imageSize = {
    width: imgW,
    height: imgH
  };
  var fitRuleStr;
  switch (fit) {
    case /* ScaleDown */0:
      fitRuleStr = "scale-down";
      break;
    case /* Cover */1:
      fitRuleStr = "cover";
      break;
    case /* Contain */2:
      fitRuleStr = "contain";
      break;
  }
  return ObjectFitMath$Showside.fitAndPosition(containerSize, imageSize, fitRuleStr);
}
function renderImg(priority, prevImg, onLoad, onRender, blur, dataTestId, dataId, borderRadiusOpt, position, originalSrc, insetOpt, altOpt, noFlickerOpt, src, imgW, imgH, containerWidth, containerHeight, fit) {
  var inset = insetOpt !== undefined ? insetOpt : false;
  var alt = altOpt !== undefined ? altOpt : "";
  var noFlicker = noFlickerOpt !== undefined ? noFlickerOpt : false;
  var containerSize_width = Belt_Option.getWithDefault(containerWidth, 9999999);
  var containerSize_height = Belt_Option.getWithDefault(containerHeight, 9999999);
  var containerSize = {
    width: containerSize_width,
    height: containerSize_height
  };
  var imageSize = {
    width: imgW,
    height: imgH
  };
  var fitRuleStr;
  switch (fit) {
    case /* ScaleDown */0:
      fitRuleStr = "scale-down";
      break;
    case /* Cover */1:
      fitRuleStr = "cover";
      break;
    case /* Contain */2:
      fitRuleStr = "contain";
      break;
  }
  var fitSize = ObjectFitMath$Showside.fitAndPosition(containerSize, imageSize, fitRuleStr);
  var intersect_width = containerSize_width < fitSize.width ? containerSize_width : fitSize.width;
  var intersect_height = containerSize_height < fitSize.height ? containerSize_height : fitSize.height;
  var tmp;
  if (blur !== undefined) {
    switch (blur) {
      case /* BlurSm */0:
        tmp = "blur(3.5px)";
        break;
      case /* BlurXl */1:
        tmp = "blur(50px)";
        break;
      case /* BlurXxl */2:
        tmp = "blur(100px)";
        break;
    }
  } else {
    tmp = undefined;
  }
  var tmp$1 = {
    height: "100%",
    left: "0px",
    position: "absolute",
    top: "0px",
    width: "100%",
    opacity: "1",
    objectFit: fitRuleStr
  };
  var tmp$2 = getObjectPosition(position);
  if (tmp$2 !== undefined) {
    tmp$1.objectPosition = tmp$2;
  }
  if (tmp !== undefined) {
    tmp$1.filter = tmp;
  }
  var tmp$3 = {
    src: src,
    width: String(fitSize.width),
    height: String(fitSize.height),
    alt: alt,
    draggable: false,
    style: tmp$1,
    dataFitRule: fitRuleStr,
    crossOrigin: "anonymous",
    onLoad: function (e) {
      if (onLoad !== undefined) {
        return Curry._1(onLoad, {
          src: src,
          width: fitSize.width,
          height: fitSize.height,
          imageSize: imageSize,
          event: e
        });
      }
    },
    onDragStart: function (e) {
      e.preventDefault();
    }
  };
  var tmp$4 = priority === 0 ? "high" : undefined;
  if (tmp$4 !== undefined) {
    tmp$3.fetchPriority = tmp$4;
  }
  if (dataTestId !== undefined) {
    tmp$3.dataTestId = Caml_option.valFromOption(dataTestId);
  }
  if (dataId !== undefined) {
    tmp$3.dataId = dataId;
  }
  if (originalSrc !== undefined) {
    tmp$3.dataOriginalSrc = originalSrc;
  }
  if (onRender !== undefined) {
    tmp$3.onRender = Caml_option.valFromOption(onRender);
  }
  return React.createElement("div", {
    className: CSS$Showside.prefix(Cn.make(["overflow-hidden", inset ? "absolute inset-0" : "relative inline-block", noFlicker ? "no-flicker" : ""])),
    style: inset ? {} : {
      height: String(intersect_height) + "px",
      width: String(intersect_width) + "px"
    }
  }, React.createElement(Image$Showside.make, tmp$3));
}
function SmartImg$InternalDebugger(Props) {
  var priority = Props.priority;
  var children = Props.children;
  var match = React.useState(function () {
    return [priority];
  });
  React.useEffect(function () {}, [priority]);
  var priorityLog = Belt_Array.map(match[0], function (log) {
    return {
      TAG: /* Log */0,
      _0: String(log)
    };
  });
  return React.createElement(Debugger$Showside.make, {
    logs: Belt_Array.concat([{
      TAG: /* Log */0,
      _0: "Priority log"
    }], priorityLog),
    enabled: false,
    className: CSS$Showside.prefix("absolute inset-0 absolute"),
    children: children
  });
}
SmartImg$InternalDebugger.displayName = "SmartImg.InternalDebugger";
var InternalDebugger = {
  make: SmartImg$InternalDebugger
};
function SmartImg$Cached(Props) {
  var src = Props.src;
  var blur = Props.blur;
  var position = Props.position;
  var containerWidth = Props.containerWidth;
  var containerHeight = Props.containerHeight;
  var borderRadius = Props.borderRadius;
  var fit = Props.fit;
  var insetOpt = Props.inset;
  var priority = Props.priority;
  var altOpt = Props.alt;
  var onLoad = Props.onLoad;
  var onRender = Props.onRender;
  var noFlickerOpt = Props.noFlicker;
  var dataTestId = Props.dataTestId;
  var dataId = Props.dataId;
  var inset = insetOpt !== undefined ? insetOpt : false;
  var alt = altOpt !== undefined ? altOpt : "";
  var noFlicker = noFlickerOpt !== undefined ? noFlickerOpt : false;
  if (!__hasQueueCycleStarted.contents) {
    __startProcessingQueueCycle(undefined);
  }
  var cached = useCached(src);
  var renderLoadingPlaceholder = function (opacity) {
    return React.createElement("div", {
      key: "loading-placeholder",
      className: Cn.make([CSS$Showside.prefix("absolute inset-0 transition-opacity duration-300 opacity-0"), CSS$Showside.prefix("bg-placeholder")]),
      style: {
        opacity: opacity.toString()
      }
    });
  };
  if (src.trim() === "") {
    return renderLoadingPlaceholder(0.0);
  } else if (cached !== undefined) {
    return React.createElement(React.Fragment, undefined, renderImg(priority, undefined, onLoad, onRender, blur, dataTestId, dataId, borderRadius, position, src, inset, alt, noFlicker, cached.src, cached.naturalWidth, cached.naturalHeight, containerWidth, containerHeight, fit), fit === /* Cover */1 ? renderLoadingPlaceholder(0.0) : null);
  } else if (fit === /* Cover */1) {
    return renderLoadingPlaceholder(1.0);
  } else {
    return null;
  }
}
SmartImg$Cached.displayName = "SmartImg.Cached";
var make = React.memo(SmartImg$Cached);
var Cached = {
  make: make
};
var loadImg = function loadImg(priority, src) {
  return new Promise((resolve, reject) => {
    let img = new Image();
    img.onload = () => {
      resolve(img);
    };
    img.onerror = () => {
      reject(img);
    };
    if (priority == 0) {
      img.fetchPriority = "high";
    }
    img.crossOrigin = "anonymous";
    img.src = src;
  });
};
function SmartImg$Sized(Props) {
  var src = Props.src;
  var containerWidth = Props.containerWidth;
  var containerHeight = Props.containerHeight;
  var naturalWidth = Props.naturalWidth;
  var naturalHeight = Props.naturalHeight;
  var fit = Props.fit;
  var onlyUseCacheOpt = Props.onlyUseCache;
  var forceBlur = Props.forceBlur;
  var borderRadius = Props.borderRadius;
  var position = Props.position;
  var insetOpt = Props.inset;
  var priority = Props.priority;
  var altOpt = Props.alt;
  var onLoad = Props.onLoad;
  var onRender = Props.onRender;
  var noFlickerOpt = Props.noFlicker;
  var dataTestId = Props.dataTestId;
  var dataId = Props.dataId;
  var onlyUseCache = onlyUseCacheOpt !== undefined ? onlyUseCacheOpt : false;
  var inset = insetOpt !== undefined ? insetOpt : false;
  var alt = altOpt !== undefined ? altOpt : "";
  var noFlicker = noFlickerOpt !== undefined ? noFlickerOpt : false;
  if (!__hasQueueCycleStarted.contents) {
    __startProcessingQueueCycle(undefined);
  }
  var cached = useCached(src);
  var queueItem = React.useRef(undefined);
  var isImgFromShopify = Shopify$Showside.isShopifyImg(src);
  var isImgFromCloudflareStream = CloudflareStream$Showside.isCloudflareStreamImg(src);
  var quantizedContainerWidth = Belt_Option.map(containerWidth, quantize);
  var quantizedContainerHeight = Belt_Option.map(containerHeight, quantize);
  var getRequiredNaturalWidth = function (naturalWidth, naturalHeight) {
    var requiredSize = calcObjectFit(naturalWidth, naturalHeight, containerWidth, containerHeight, fit);
    var dpr = Cloudinary$Showside.getDevicePixelRatio(src);
    return Math.imul(requiredSize.width, dpr);
  };
  var match;
  if (cached !== undefined) {
    var requiredNaturalWidth = getRequiredNaturalWidth(cached.naturalWidth, cached.naturalHeight);
    var howGoodIsCache = cached.naturalWidth / requiredNaturalWidth;
    match = [howGoodIsCache, [cached.naturalWidth, cached.naturalHeight]];
  } else {
    match = naturalWidth !== undefined ? naturalHeight !== undefined ? [0.0, [naturalWidth, naturalHeight]] : [0.0, [undefined, undefined]] : [0.0, [undefined, undefined]];
  }
  var naturalSize = match[1];
  var howGoodIsCache$1 = match[0];
  var cloudSrc = fit !== 1 ? isImgFromShopify ? Shopify$Showside.makeUrl(src, quantizedContainerWidth, quantizedContainerHeight, Cloudinary$Showside.getDevicePixelRatio(src), undefined) : isImgFromCloudflareStream ? CloudflareStream$Showside.Thumbnail.makeUrl(quantizedContainerWidth, quantizedContainerHeight, function (param) {
    var func = function (param$1, param$2, param$3, param$4) {
      return Cloudinary$Showside.makeUrl(param, param$1, param$2, param$3, param$4);
    };
    return function (param, param$1) {
      return Curry._3(func, param, param$1, /* Fit */2);
    };
  }, src) : Cloudinary$Showside.makeUrl(src, quantizedContainerWidth, quantizedContainerHeight, /* Fit */2, undefined) : isImgFromShopify ? Shopify$Showside.makeCoverUrl(src, quantizedContainerWidth, quantizedContainerHeight, naturalSize[0], naturalSize[1], Cloudinary$Showside.getDevicePixelRatio(src), undefined) : isImgFromCloudflareStream ? CloudflareStream$Showside.Thumbnail.makeCoverUrl(quantizedContainerWidth, quantizedContainerHeight, Cloudinary$Showside.makeCoverUrl, src) : Cloudinary$Showside.makeCoverUrl(src, quantizedContainerWidth, quantizedContainerHeight, undefined);
  var isSvg = cloudSrc.includes("/f_svg,");
  var canUseCachePermanently = onlyUseCache || howGoodIsCache$1 > 0.95;
  var soBadWeShouldBlur = isSvg ? false : isImgFromShopify ? howGoodIsCache$1 < 0.1 : howGoodIsCache$1 < 0.75;
  var loader = React.useCallback(function (param) {
    return $$Promise.$$catch(loadImg(priority, cloudSrc).then(function (img) {
      var naturalWidth = img.width;
      var naturalHeight = img.height;
      setCached(src, {
        src: cloudSrc,
        naturalWidth: naturalWidth,
        naturalHeight: naturalHeight,
        color: ColorFromImage$Showside.getColor(img)
      });
    }), function (param) {
      return Promise.resolve(undefined);
    });
  }, [loadImg, cloudSrc, src, setCached]);
  React.useEffect(function () {
    if (!canUseCachePermanently) {
      var item = queueItem.current;
      if (item !== undefined) {
        queueItem.current = updateQueueItem(item, priority, loader);
      } else {
        queueItem.current = enqueue(priority, loader);
      }
    }
  }, [canUseCachePermanently, queueItem.current, updateQueueItem, priority, loader, enqueue]);
  React.useEffect(function () {
    return function (param) {
      var item = queueItem.current;
      if (item !== undefined) {
        return cancelQueued(item);
      }
    };
  }, []);
  var blur = React.useMemo(function () {
    if (forceBlur !== undefined) {
      return forceBlur;
    } else if (soBadWeShouldBlur) {
      return /* BlurSm */0;
    } else {
      return;
    }
  }, [forceBlur, soBadWeShouldBlur]);
  var tmp = {
    src: src,
    containerWidth: containerWidth,
    containerHeight: containerHeight,
    fit: fit,
    inset: inset,
    priority: priority,
    alt: alt,
    noFlicker: noFlicker
  };
  if (blur !== undefined) {
    tmp.blur = Caml_option.valFromOption(blur);
  }
  if (position !== undefined) {
    tmp.position = Caml_option.valFromOption(position);
  }
  if (borderRadius !== undefined) {
    tmp.borderRadius = Caml_option.valFromOption(borderRadius);
  }
  if (onLoad !== undefined) {
    tmp.onLoad = Caml_option.valFromOption(onLoad);
  }
  if (onRender !== undefined) {
    tmp.onRender = Caml_option.valFromOption(onRender);
  }
  if (dataTestId !== undefined) {
    tmp.dataTestId = Caml_option.valFromOption(dataTestId);
  }
  if (dataId !== undefined) {
    tmp.dataId = Caml_option.valFromOption(dataId);
  }
  return React.createElement(make, tmp);
}
SmartImg$Sized.displayName = "SmartImg.Sized";
var make$1 = React.memo(SmartImg$Sized);
var Sized = {
  make: make$1
};
function SmartImg(Props) {
  var src = Props.src;
  var fit = Props.fit;
  var infiniteWidthOpt = Props.infiniteWidth;
  var infiniteHeightOpt = Props.infiniteHeight;
  var onlyUseCacheOpt = Props.onlyUseCache;
  var forceBlur = Props.forceBlur;
  var borderRadiusOpt = Props.borderRadius;
  var insetOpt = Props.inset;
  var altOpt = Props.alt;
  var priority = Props.priority;
  var onLoad = Props.onLoad;
  var onRender = Props.onRender;
  var noFlickerOpt = Props.noFlicker;
  var dataTestId = Props.dataTestId;
  var dataId = Props.dataId;
  var infiniteWidth = infiniteWidthOpt !== undefined ? infiniteWidthOpt : false;
  var infiniteHeight = infiniteHeightOpt !== undefined ? infiniteHeightOpt : false;
  var onlyUseCache = onlyUseCacheOpt !== undefined ? onlyUseCacheOpt : false;
  var borderRadius = borderRadiusOpt !== undefined ? borderRadiusOpt : false;
  var inset = insetOpt !== undefined ? insetOpt : true;
  var alt = altOpt !== undefined ? altOpt : "";
  var noFlicker = noFlickerOpt !== undefined ? noFlickerOpt : false;
  if (!__hasQueueCycleStarted.contents) {
    __startProcessingQueueCycle(undefined);
  }
  var src$1 = src !== undefined && src !== "" ? src : undefined;
  var fit$1 = fit === /* ScaleDown */0 ? /* Contain */2 : fit;
  var ref = React.useRef(null);
  var size = ResizeObserver2$Showside.useResizeObserver(ref);
  var renderMeasure = function (param) {
    return React.createElement(Spread$Showside.make, {
      props: {
        "data-original-src": src$1,
        "data-fit-rule": fit$1
      },
      children: React.createElement("div", {
        ref: ReactDOMUtils$Showside.Ref.domRef(ref),
        className: CSS$Showside.prefix("absolute inset-0 pointer-events-none")
      })
    });
  };
  var renderImg = function (src) {
    if (size === undefined) {
      return React.createElement("div", {
        key: "loading-placeholder",
        className: Cn.make([CSS$Showside.prefix("absolute inset-0 transition-opacity duration-300 opacity-1"), CSS$Showside.prefix("bg-placeholder")])
      });
    }
    var effectiveWidth = infiniteWidth ? undefined : size.width;
    var effectiveHeight = infiniteHeight ? undefined : size.height;
    var tmp = {
      src: src,
      fit: fit$1,
      onlyUseCache: onlyUseCache,
      borderRadius: borderRadius,
      inset: inset,
      priority: priority,
      alt: alt,
      noFlicker: noFlicker
    };
    if (effectiveWidth !== undefined) {
      tmp.containerWidth = effectiveWidth;
    }
    if (effectiveHeight !== undefined) {
      tmp.containerHeight = effectiveHeight;
    }
    if (forceBlur !== undefined) {
      tmp.forceBlur = Caml_option.valFromOption(forceBlur);
    }
    if (onLoad !== undefined) {
      tmp.onLoad = Caml_option.valFromOption(onLoad);
    }
    if (onRender !== undefined) {
      tmp.onRender = Caml_option.valFromOption(onRender);
    }
    if (dataTestId !== undefined) {
      tmp.dataTestId = Caml_option.valFromOption(dataTestId);
    }
    if (dataId !== undefined) {
      tmp.dataId = Caml_option.valFromOption(dataId);
    }
    return React.createElement(SmartImg$InternalDebugger, {
      priority: priority,
      children: React.createElement(make$1, tmp)
    });
  };
  if (src$1 !== undefined) {
    return React.createElement(React.Fragment, undefined, renderMeasure(undefined), renderImg(src$1));
  } else {
    return null;
  }
}
SmartImg.displayName = "SmartImg";
function SmartImg$ColorOverlay$Color(Props) {
  var src = Props.src;
  var match = ConfigurationProvider$Showside.use(undefined);
  var color = Belt_Option.getWithDefault(Belt_Option.flatMap(useCached(src), function (c) {
    return c.color;
  }), match.config.settings.pdpGalleryBGColor);
  return React.createElement("div", {
    className: CSS$Showside.prefix("pointer-events-none absolute inset-0"),
    style: {
      backgroundColor: color
    }
  });
}
SmartImg$ColorOverlay$Color.displayName = "SmartImg.ColorOverlay.Color";
var Color = {
  make: SmartImg$ColorOverlay$Color
};
function SmartImg$ColorOverlay(Props) {
  var media = Props.media;
  var src = Props.src;
  var src$1;
  if (src !== undefined) {
    src$1 = src;
  } else if (media !== undefined) {
    switch (media.TAG | 0) {
      case /* Image */0:
        src$1 = media._0.url;
        break;
      case /* Video */1:
        src$1 = media._0.posterUrl;
        break;
      case /* IframeEmbed */2:
        src$1 = undefined;
        break;
    }
  } else {
    src$1 = undefined;
  }
  if (src$1 !== undefined) {
    return React.createElement(SmartImg$ColorOverlay$Color, {
      src: src$1
    });
  } else {
    return null;
  }
}
SmartImg$ColorOverlay.displayName = "SmartImg.ColorOverlay";
var ColorOverlay = {
  Color: Color,
  make: SmartImg$ColorOverlay
};
var enableDebugger = false;
var infinity = 9999999;
var make$2 = SmartImg;
export { enableDebugger, infinity, sizes, quantize, getObjectPosition, cache, cacheEntryCallbacks, getCached, setCached, useCached, queue, pending, timeout, getPriorityBatchLimit, runQueueItem, waitForIdle, processQueueCycle, sortQueue, enqueue, cancelQueued, updateQueueItem, __hasQueueCycleStarted, __startProcessingQueueCycle, calcObjectFit, renderImg, InternalDebugger, Cached, loadImg, Sized, make$2 as make, ColorOverlay };
/* make Not a pure module */